export default __webpack_public_path__ + "static/media/nada.2135e6ca.jpg";